module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/绿色制造.737e1dda.png";